import type { Route } from 'next';
import LinkButton from '../../../../components/form/LinkButton/LinkButton';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { LOTTERY_DRAW_TYPE } from '../../constants';
import type { LotteryDrawResult } from '../../types';
import styles from './CampaignLotteryDrawResultNothing.module.scss';

type CampaignLotteryDrawResultNothingProps = {
  lotteryDrawResult: LotteryDrawResult;
  /** fanychanceの場合にクエリパラメータを追加するかどうか */
  isShowModalQuery?: boolean;
};

function CampaignLotteryDrawResultNothing({
  lotteryDrawResult,
  isShowModalQuery = false,
}: CampaignLotteryDrawResultNothingProps) {
  const getSerialCodeRetryHref = (): Route<string> => {
    const baseUrl = `/campaign-lotteries/${String(lotteryDrawResult.lotteryEventBranchId)}`;
    return isShowModalQuery ? (`${baseUrl}?showModal=true` as Route<string>) : (baseUrl as Route<string>);
  };

  const serialCodeRetryHref = getSerialCodeRetryHref();

  return (
    <div>
      {/* 初回シリアルコードのみの場合のテキスト */}
      {lotteryDrawResult.drawType === LOTTERY_DRAW_TYPE.first_serial_code.value && (
        <div className={styles.induceText}>
          <p>
            キャンペーンくじに参加していただいた方限定で、
            <br />
            豪華景品が当たるハズレなし「スペシャルくじ」にチャレンジできます。
            <br />
            ※こちらは有料になります
          </p>
        </div>
      )}
      {/* ハズレ画像 */}
      {lotteryDrawResult.lotteryEventBranchMissingImageUrl && (
        <div className={utilsStyles.mtMedium}>
          <ImageView src={lotteryDrawResult.lotteryEventBranchMissingImageUrl} alt='' isFreeSize />
        </div>
      )}
      <div className={`${utilsStyles.mtMedium} ${layoutStyles.centeredBtnWrapper}`}>
        {lotteryDrawResult.drawType === LOTTERY_DRAW_TYPE.first_serial_code.value ? (
          <>
            {/* 初回シリアルコードのみくじの場合 */}
            <LinkButton color='primary' href={`/lotteries/${lotteryDrawResult.lotteryEventId}`}>
              スペシャルくじにチャレンジ
            </LinkButton>
            <LinkButton outlined href={`/campaign-lotteries/${lotteryDrawResult.lotteryEventBranchId}`}>
              シリアルコードでもう一度引く
            </LinkButton>
          </>
        ) : (
          <>
            {/* 初回シリアルコードのみくじ以外 */}
            <LinkButton color='primary' href={serialCodeRetryHref}>
              シリアルコードでもう一度引く
            </LinkButton>
            <LinkButton outlined href={`/campaign-lotteries/${lotteryDrawResult.lotteryEventBranchId}`}>
              イベントページに戻る
            </LinkButton>
          </>
        )}
      </div>
    </div>
  );
}

export default CampaignLotteryDrawResultNothing;
